import { ApiClient } from "./api/index";
import { MqttClient } from "./MqttClient";
import { AppState, SystemNotificationStore, PresenceStore, StatusPageStore } from "./stores/index";

export const apiClient = new ApiClient();

export const appState = new AppState();
export const systemNotificationStore = new SystemNotificationStore(appState);
export const presenceStore = new PresenceStore();
export const statusPageStore = new StatusPageStore();

export const mqttClient = new MqttClient(appState, presenceStore);



// WEBPACK FOOTER //
// ./src/lib/instances.ts